export default __webpack_public_path__ + "static/media/okex.61292adf.webp";